import { render, staticRenderFns } from "./TheContainer.vue?vue&type=template&id=4686fdc4&scoped=true&"
import script from "./TheContainer.vue?vue&type=script&lang=js&"
export * from "./TheContainer.vue?vue&type=script&lang=js&"
import style0 from "./TheContainer.vue?vue&type=style&index=0&id=4686fdc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4686fdc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4686fdc4')) {
      api.createRecord('4686fdc4', component.options)
    } else {
      api.reload('4686fdc4', component.options)
    }
    module.hot.accept("./TheContainer.vue?vue&type=template&id=4686fdc4&scoped=true&", function () {
      api.rerender('4686fdc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/TheContainer.vue"
export default component.exports